import {config, library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'
import {
    faAddressCard, faAngleDown, faArrowRight, faAt, faBan, faBars, faBed, faCalendar, faCalendarAlt, 
    faCalendarDay, faCalendarPlus, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, faCheckCircle, 
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCircleDot, faCircleInfo, faCircleNotch, 
    faCoins, faConciergeBell, faCopy, faCreditCard, faDownload, faExclamationCircle, faExclamationTriangle, 
    faExpand, faExternalLinkAlt, faEyeSlash, faFile, faFileAlt, faFileContract, faFileDownload, faFileExcel, 
    faFileImage, faFileInvoice, faFilePdf, faFileWord, faGlobe, faGrip, faHashtag, faHome, faHourglassEnd, 
    faIdCard, faIndustry, faInfo, faInfoCircle, faLink, faListUl, faLocationCrosshairs, faMap, faMapLocationDot, faMapMarkerAlt, 
    faMars, faMobileScreen, faNeuter, faPaperPlane, faPassport, faPen, faPhone, faPlay, faPlus, faPrint, faQuestion, faQuestionCircle, 
    faRoute, faSearch, faTimes, faTrash, faUser, faUserFriends, faUserTie, faUsers, faUtensils, faVenus, 
    faWheelchair
} from '@fortawesome/free-solid-svg-icons'
import {
    faCalendar as faCalendarRegular, faCircle as faCircleRegular, faComment as faCommentRegular
} from '@fortawesome/free-regular-svg-icons'
import {
    faPaypal as faPaypalBrand
} from '@fortawesome/free-brands-svg-icons'

// Explicit list instead of library.add(fas/far/fab): the three packs are 2051 icons and 1.31 MB of
// path data, of which this app renders 83. Every name below was resolved against the installed
// packs. An icon that is not registered renders empty without an error, so add new ones here as you
// use them rather than reaching back for a whole pack.
const icons = [
    faAddressCard, faAngleDown, faArrowRight, faAt, faBan, faBars, faBed, faCalendar, faCalendarAlt, 
    faCalendarDay, faCalendarPlus, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, faCheckCircle, 
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCircleDot, faCircleInfo, faCircleNotch, 
    faCoins, faConciergeBell, faCopy, faCreditCard, faDownload, faExclamationCircle, faExclamationTriangle, 
    faExpand, faExternalLinkAlt, faEyeSlash, faFile, faFileAlt, faFileContract, faFileDownload, faFileExcel, 
    faFileImage, faFileInvoice, faFilePdf, faFileWord, faGlobe, faGrip, faHashtag, faHome, faHourglassEnd, 
    faIdCard, faIndustry, faInfo, faInfoCircle, faLink, faListUl, faLocationCrosshairs, faMap, faMapLocationDot, faMapMarkerAlt, 
    faMars, faMobileScreen, faNeuter, faPaperPlane, faPassport, faPen, faPhone, faPlay, faPlus, faPrint, faQuestion, faQuestionCircle, 
    faRoute, faSearch, faTimes, faTrash, faUser, faUserFriends, faUserTie, faUsers, faUtensils, faVenus, 
    faWheelchair, faCalendarRegular, faCircleRegular, faCommentRegular, faPaypalBrand,
]

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(...icons)

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon, {})
    nuxtApp.vueApp.component('font-awesome-layers', FontAwesomeLayers, {})
    nuxtApp.vueApp.component('font-awesome-layers-text', FontAwesomeLayersText, {})
})
